<template>
	<div>
		<v-row v-if="! property">
			<v-col>
				<v-text-field
					v-model.trim="search"
					append-icon="mdi-magnify"
					placeholder="Search..."
					name="search"
					autocomplete="off"
					single-line
					clearable
					filled
					dense
					outlined
					full-width
					autofocus
					hide-details
					@input="searchInput" />
				<v-simple-table
					v-if="results"
					dense
					class="mt-2">
					<thead>
						<tr>
							<th style="padding-left: 8px">Asset Address</th>
							<th>Asset Relationship</th>
							<th>Loan Seller</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="result in results" :key="result.id">
							<td style="font-size:92%">{{ result.full_address }}</td>
							<td style="font-size:92%">{{ result.asset_relationship }}</td>
							<td style="font-size:92%">{{ result.loan_seller }}</td>
							<td style="font-size:92%">
								<v-btn
									color="success"
									rounded
									x-small
									class="pl-2 pr-2"
									:disabled="alreadyAdded.includes(result.id)"
									@click="addProperty(result)">
									<v-icon x-small>mdi-arrow-down</v-icon>
									<span v-if="! alreadyAdded.includes(result.id)">Add</span>
									<span v-else>Added</span>
								</v-btn>
							</td>
						</tr>
					</tbody>
				</v-simple-table>
			</v-col>
		</v-row>
		<v-row v-if="! property">
			<v-col cols="3" class="d-flex align-center justify-center mb-2">
				<hr style="width: 100%; opacity: 50%" />
			</v-col>
			<v-col cols="6" class="mb-2">
				<v-row>
					<v-col cols="2" class="d-flex align-center justify-center"><v-icon color="grey lighten-2">mdi-arrow-up</v-icon></v-col>
					<v-col cols="8" class="text-center">Search for a previously entered property to copy into this project or add a new below.</v-col>
					<v-col cols="2" class="d-flex align-center justify-center"><v-icon color="grey lighten-2">mdi-arrow-down</v-icon></v-col>
				</v-row>
			</v-col>
			<v-col cols="3" class="d-flex align-center justify-center mb-2">
				<hr style="width: 100%; opacity: 50%" />
			</v-col>
		</v-row>
		<v-form v-model="formValid" @submit.prevent="handleForm">
			<v-row>
				<v-col>
					<v-text-field
						v-model="form.address_1"
						label="Address"
						name="address_1"
						:error="hasErrors(form, 'address_1')"
						:error-messages="errorMsg(form, 'address_1')"
						persistent-placeholder
						autofocus
						outlined
						required
						dense />
					<v-text-field
						v-model="form.address_2"
						label="Address 2"
						name="address_2"
						:error="hasErrors(form, 'address_2')"
						:error-messages="errorMsg(form, 'address_2')"
						persistent-placeholder
						outlined
						required
						dense />
					<v-row>
						<v-col cols="12" md="4">
							<v-text-field
								v-model="form.city"
								label="City"
								name="city"
								:error="hasErrors(form, 'city')"
								:error-messages="errorMsg(form, 'city')"
								persistent-placeholder
								outlined
								required
								dense />
						</v-col>
						<v-col cols="12" md="4">
							<v-autocomplete
								v-model="form.state_id"
								:items="states"
								:error="hasErrors(form, 'state_id')"
								:error-messages="errorMsg(form, 'state_id')"
								persistent-placeholder
								item-text="name"
								item-value="id"
								label="Select State"
								outlined
								dense
								clearable
								required
								eager />
						</v-col>
						<v-col cols="12" md="4">
							<v-text-field
								v-model="form.zipcode"
								label="Zip Code"
								name="zipcode"
								:error="hasErrors(form, 'zipcode')"
								:error-messages="errorMsg(form, 'zipcode')"
								persistent-placeholder
								outlined
								required
								dense />
						</v-col>
					</v-row>
					<v-divider class="mt-0 mb-5" />
					<v-row>
						<v-col cols="12" md="6">
							<v-text-field
								v-model="form.asset_relationship"
								label="Asset Relationship"
								name="Asset Relationship"
								:error="hasErrors(form, 'asset_relationship')"
								:error-messages="errorMsg(form, 'asset_relationship')"
								persistent-placeholder
								outlined
								required
								dense />
						</v-col>
						<v-col cols="12" md="6">
							<v-combobox
								v-model="form.type"
								:items="types"
								:error="hasErrors(form, 'type')"
								:error-messages="errorMsg(form, 'type')"
								persistent-placeholder
								label="Property Type"
								outlined
								:return-object="false"
								dense />
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" md="4">
							<!--							<v-text-field-->
							<!--								v-model="form.loan_seller"-->
							<!--								name="loan_seller"-->
							<!--								label="Loan Seller"-->
							<!--								placeholder="Not Provided"-->
							<!--								:error="hasErrors(form, 'loan_seller')"-->
							<!--								:error-messages="errorMsg(form, 'loan_seller')"-->
							<!--								outlined-->
							<!--								dense />-->
							<v-select
								v-model="form.loan_seller"
								:items="['Pre-lending due diligence', 'Pre-purchase due diligence', 'Pre-foreclosure due diligence']"
								name="loan_seller"
								label="Loan Seller"
								placeholder="Not Provided"
								:error="hasErrors(form, 'loan_seller')"
								:error-messages="errorMsg(form, 'loan_seller')"
								persistent-placeholder
								outlined
								dense />
						</v-col>
						<v-col cols="12" md="4">
							<v-text-field
								v-model="form.pool_asset_number"
								name="pool_asset_number"
								label="Pool/Asset #"
								placeholder="Not Provided"
								:error="hasErrors(form, 'pool_asset_number')"
								:error-messages="errorMsg(form, 'pool_asset_number')"
								persistent-placeholder
								outlined
								dense />
						</v-col>
						<v-col cols="12" md="4">
							<v-text-field
								v-model="form.upb"
								name="upb"
								label="UPB"
								placeholder="Not Provided"
								:error="hasErrors(form, 'upb')"
								:error-messages="errorMsg(form, 'upb')"
								persistent-placeholder
								outlined
								dense />
						</v-col>
					</v-row>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-divider class="mt-0 mb-5" />
					<v-btn type="submit"
						color="success"
						large
						v-text="buttonLabel" />
				</v-col>
			</v-row>
		</v-form>
	</div>
</template>
<script>
import states from '@/Mixins/states'
import api from '@/api'

export default {
	mixins: [ states ],
	props: {
		property: {
			type: Object,
			default: () => {}
		},
		project: {
			type: Object,
			default: () => {}
		}
	},
	data () {
		return {
			reportTypes: [],
			formValid: true,
			propertySearching: false,
			types: this.$page.props.propertyTypes,
			form: this.$inertia.form({
				address_1: null,
				address_2: null,
				city: null,
				state_id: null,
				zipcode: null,
				type: null,
				asset_relationship: null,
				loan_seller: null,
				pool_asset_number: null,
				upb: null
			}),
			search: null,
			results: null,
			alreadyAdded: []
		}
	},
	computed: {
		buttonLabel () {
			if (this.property) {
				return 'Update Property'
			}

			return 'Add Property'
		}
	},
	watch: {
		propertySearch (newVal, oldVal) {
			if (newVal && newVal === oldVal) {
				return
			}

			if (! newVal) {
				this.results = []
			}

			this.handleSearch(newVal)
		}
	},
	mounted () {
		this.populateForm()
	},
	methods: {
		handleForm () {
			if (this.property) {
				this.form.put(this.route('properties.update', this.property), {
					only: ['properties', 'property', 'errors', 'flash'],
					preserveScroll: true,
					preserveState: true,
					onSuccess: () => {
						this.$emit('success')
					}
				})

				return
			}

			this.form.post(this.route('properties.store', {
				'project': this.project,
				'property': this.property
			}), {
				only: ['properties', 'errors', 'flash'],
				onSuccess: () => {
					this.$emit('success')
					this.form.reset()
				}
			})
		},

		populateForm () {
			if (this.property) {
				for (const clientKey in this.property) {
					if (!this.property.hasOwnProperty(clientKey)) continue
					if (this.form.hasOwnProperty(clientKey)) {
						this.form[clientKey] = this.property[clientKey]
					}
				}
			}
		},

		searchInput () {
			if (this.search.length > 5) {
				this.handleSearch()
			}
		},

		handleSearch () {
			const method = 'POST'
			const data = { search: this.search }
			const url = this.route('properties.search')
			this.propertySearching = true

			api({
				method,
				url,
				data
			}).then(response => {
				this.results = response.data
				this.propertySearching = false
			})
		},

		addProperty (property) {
			this.alreadyAdded.push(property.id)
			this.$inertia.post(this.route('properties.add-to-project', {
				'project': this.project,
				'property': property
			}), {
				only: ['properties', 'errors', 'flash'],
				preserveScroll: true,
				preserveState: true,
				onSuccess: () => {
					this.$emit('success')
				}
			})
		}
	}
}
</script>
